import React, { useState, useRef, useEffect } from "react";
import { Box, TextField, Grid } from "@mui/material";

const OTPInput = ({ length = 6, onComplete }) => {
  const [otp, setOTP] = useState(Array(length).fill(""));
  const inputRefs = useRef(Array(length).fill(null));

  const focusInput = (index) => {
    if (inputRefs.current[index]) {
      inputRefs.current[index].focus();
    }
  };

  const handleChange = (e, index) => {
    const { value } = e.target;

    if (!isNaN(value) && value !== "") {
      const newOTP = [...otp];
      newOTP[index] = value;
      setOTP(newOTP);

      // Check if all OTP fields are filled
      if (!newOTP.includes("")) {
        onComplete(newOTP.join(""));
        // setOTP(Array(length).fill(''));
      }

      // Move focus to the next input field if available
      if (index < length - 1) {
        focusInput(index + 1);
      }
    }
  };

  const handleKeyUp = (e, index) => {
    if (e.key === 'Backspace') {
      // Prevent the default behavior of the Backspace key
      e.preventDefault();
  
      if (index > 0) {
        // Move focus to the previous input field when backspace is pressed
        focusInput(index - 1);
  
        // Clear the value in the current field
        const newOTP = [...otp];
        newOTP[index] = '';
        setOTP(newOTP);
      } else {
        // If Backspace is pressed in the first field, clear the value in the first field
        const newOTP = [...otp];
        newOTP[index] = '';
        setOTP(newOTP);
      }
    } else if (e.key === 'ArrowLeft') {
      if (index > 0) {
        // Move focus to the previous input field when left arrow is pressed
        focusInput(index - 1);
      }
    } else if (e.key === 'ArrowRight') {
      if (index < length - 1) {
        // Move focus to the next input field when right arrow is pressed
        focusInput(index + 1);
      }
    }
  };
  
  
  
  

  useEffect(() => {
    // Focus on the first input field initially
    focusInput(0);
  }, []);

  useEffect(() => {
    // Reset OTP fields when onComplete is called
    setOTP(Array(length).fill(""));
  }, [onComplete, length]);

  return (
    <Grid
      style={{ display: "flex", justifyContent: "center" }}
      container
      spacing={1}
    >
      {otp.map((value, index) => (
        <Grid item xs={1} md={1} sm={2} key={index}>
          <TextField
            id={`otp-input-${index}`}
            type="text"
            variant="outlined"
            fullWidth
            inputProps={{ maxLength: 1 }}
            value={value}
            onChange={(e) => handleChange(e, index)}
            onKeyUp={(e) => handleKeyUp(e, index)}
            inputRef={(ref) => (inputRefs.current[index] = ref)}
            size="small"
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default OTPInput;
